import moment from '@/moment-gp'
import GoalAndCommitmentPromptMixin from '@/components/Mixins/Prompts/GoalAndCommitmentPrompt'
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"
import GiphyMixin from "@/components/Mixins/Giphy"
import { FEATURE_BUG_BOUNTY } from '@/features'
import clonedeep from "lodash.clonedeep";
import { mapActions, mapGetters } from "vuex";
import notificationSound from "@/assets/sounds/file-sounds-1103-quite-impressed.mp3";

export default {
  mixins: [ GoalAndCommitmentPromptMixin, ConfirmDeletePromptMixin, GiphyMixin ],
  data: () => ({
    dragTaskItemFrom: null
  }),
  created() {
    this.task_finished_sound = new Audio(notificationSound)
  },
  computed: {
    ...mapGetters("dayplanner", [
      "drag_item",
      'dayplanner_unfinished_tasks',
      'dayplanner_unfinished_tasks_old'
    ]),
    ...mapGetters("session",[
      "session_user_timer",
      'session_timer_taskId',
    ]),
  },
  methods: {
    ...mapActions("dayplanner", [
      "setDragItem",
      "setDragItemType"
    ]),
    ...mapActions("session",[
      "session_timer_start",
      "session_timer_pause",
      "session_timer_stop",
    ]),

    _task_info() {
      return  {
        $id:      this.task.$id      || this.taskId,
        taskId:   this.task.$id      || this.taskId,
        goalId:   this.task.goalId   || this.goalId,
        memberId: this.task.memberId || this.memberId,
        laneId:   this.task.laneId   || this.laneId,
      }
    },

    _session_info() {
      return {
        tasksInSession: this.tasksInSession,
        sessionId:      this.sessionId
      }
    },

    /* ---------------------------------------------------------------------- */
    task_meta_update(payload) {
      /* overwritten in TaskPage */
      console.log("task meta update: mixin");
      this.$models.taskMeta
        .with({
          goalId: this.goalId,
          uid:    this.memberId
        })
        .update( this.task.$id, payload);
    },

    /* ---------------------------------------------------------------------- */
    onSetTaskName(newTaskName) {
      let task = this._task_info()
      // console.log("Updating goal title to ", this.goalId, newTaskName);

      this.$api.task_set_title({
        member_id:  task.memberId,
        goal_id:    task.goalId,
        task_id:    task.$id,
        name:       newTaskName,
      });
    },

    /* ---------------------------------------------------------------------- */
    onShowTaskModal() {
      /* overwritten in TaskPage */
      let task = this._task_info()
      this.$root.showUpdateModal('task', {
        memberId: task.memberId,
        goalId:   task.goalId,
        taskId:   task.$id
      })
    },

    /* ---------------------------------------------------------------------- */
    onDragTaskStart(item) {
      console.log('TaskManagement onDragTaskStart', item)
      this.setDragItem(clonedeep(item))
    },

    onDragTaskEnd(destination) {
      console.log('onDragTaskEnd', destination)
      if (this.drag_item ) { // && !this.drag_item.dragEnded
        // make sure this is only triggered once
        //this.dragTaskItemFrom.dragEnded = true;
        // change assigned member if necessary
        let source = this.drag_item;
        // calculate sortidx
        let draggablesList = destination.draggablesList;
        let tasklistAll = clonedeep(destination.tasklistAll).filter(task => task.taskId !== source.taskId);
        let newIndex = destination.newIndex;
        let sortidx = -1;
        //console.log("onDragAdd $event.newIndex", newIndex, "Draggables List", clonedeep(draggablesList), newIndex, 'tasklistAll:', tasklistAll);
        //console.log("onDragAdd test",source.listId === destination.listId && source.listType === destination.listType, (source.sessionId === destination.sessionId  || (!source.sessionId && !destination.sessionId)));
        if (source.listId === destination.listId && source.listType === destination.listType && (source.sessionId === destination.sessionId  || (!source.sessionId && !destination.sessionId))) {
          //console.log('moved in same list')
          if (source.oldIndex < newIndex) {
            newIndex += 1
          }

        }
        console.log('newIndex', newIndex, draggablesList.length)
        if (newIndex < draggablesList.length) {
          // insert above first element
          // TODO: insert into sessions lists where no tasks exist
          let placeAboveTaskId = draggablesList[newIndex].$id;
          let placeAboveTasklistIndex = tasklistAll.findIndex(task => task.$id === placeAboveTaskId);
          if (placeAboveTasklistIndex === 0 && tasklistAll.length === 0) {
            sortidx = 1;
          } else if (placeAboveTasklistIndex === 0) {
            sortidx = tasklistAll[placeAboveTasklistIndex].$state.sortidx / 2;
            //console.log('onDragAdd sortidx marker1.1', sortidx, tasklistAll)
          } else if (placeAboveTasklistIndex < tasklistAll.length) {
            sortidx =
              (tasklistAll[placeAboveTasklistIndex - 1].$state.sortidx + tasklistAll[placeAboveTasklistIndex].$state.sortidx) / 2;
              //console.log('onDragAdd sortidx marker1.2', sortidx, tasklistAll)
          } else {
          }
          //console.log('onDragAdd sortidx marker1', sortidx)
        } else if (newIndex >= draggablesList.length) {
          //console.log('onDragAdd sortidx marker2.0', sortidx)
          // insert behind last element
          if (draggablesList.length === 0) {
            if (tasklistAll.length === 0) {
              sortidx = 1;
            } else {
              sortidx = tasklistAll[tasklistAll.length - 1].$state.sortidx + 1;
              //console.log('onDragAdd sortidx marker2.1', sortidx, tasklistAll)
            }
          } else {
            sortidx = tasklistAll[tasklistAll.length - 1].$state.sortidx + 1;
            //console.log('onDragAdd sortidx marker2.2', sortidx, tasklistAll)
          }
          //console.log('onDragAdd sortidx marker2', sortidx)
        }
        sortidx = sortidx !== -1 ? sortidx : source.sortidx;
        //console.log('onDragAdd sortidx', sortidx)

        if (
          source.listId !== destination.listId ||
          source.sortidx !== sortidx ||
          source.sessionId !== destination.sessionId
        ) {
          let newSessionId = destination.listType === "planned" ? destination.sessionId : null;
          //let sortidx = sortidx !== -1 ? sortidx : source.sortidx
          /*console.log(
            "onDragTaskEnd updating taskMeta with",
            source.goalId,
            source.memberId,
            source.taskId,
            sortidx,
            "sortidx:",
            sortidx
          );*/
          this.$models.taskMeta
            .with({
              goalId: source.goalId,
              uid: source.memberId,
            })
            .update(source.taskId, {
              laneId: destination.listId,
              sortidx: sortidx,
              sessionId: newSessionId,
            });

          //console.log("onDragTaskEnd updating sessionId from ", clonedeep(source.sessionId), " to ", clonedeep(destination.sessionId));

          //console.log("onDragTaskEnd newSessionId", newSessionId);
          if (newSessionId  && this.isDayplan) {
            this.onAddTaskToSession({
              goalId: source.goalId,
              memberId: source.memberId,
              taskId: source.taskId,
              tasksInSession: destination.tasksInSession,
              sessionId: destination.sessionId,
            });
            if (this.drag_item.sessionId && this.drag_item.sessionId !==  destination.sessionId) {
              console.log('remove task from old session source', source)
              let sessionData = this.$models.userDayplannerSessions.with({ sessionId: this.drag_item.sessionId, uid: source.memberId }).subscribeNode(this.drag_item.sessionId);
              let tasksInSession = sessionData.tasks
              console.log('sessionData', sessionData, tasksInSession)
              this.onRemoveTaskFromSession( source, { sessionId: this.drag_item.sessionId, tasksInSession: tasksInSession }, true );
            }
          } else if (source.sessionId && this.isDayplan) {
            this.onRemoveTaskFromSession( source, destination );
          }
        }
        if (source.goalId === destination.goalId && source.memberId !== destination.memberId) {
          this.$api.task_assign_to_lane({
            /* Item is changing owner and now has the user ID of the target
             * lane (this one). item.memberId is the old user ID! */
            old_member_id: source.memberId,
            new_member_id: destination.memberId,
            goal_id: source.goalId,
            lane_id: destination.listId,
            task_id: source.taskId,
          });
        }
        if (source.goalId !== destination.goalId) {
          this.$api.task_assign_to_goal({
            src_goal_id: source.goalId,
            dst_goal_id: destination.goalId,
            src_commitment_id: source.listId,
            dst_commitment_id: destination.listId,
            src_member_id: source.memberId,
            dst_member_id: destination.memberId,
            task_id: source.taskId,
          });
        }

      }
      this.setDragItem(null)
    },

    onAddTaskToSession({ goalId, memberId, taskId, tasksInSession, sessionId }) {
      if (sessionId) {
        let sessionData = this.$models.userDayplannerSessions.with({ sessionId: sessionId, uid: memberId }).subscribeNode(sessionId);
        let taskData = this.$models.taskMeta.with({ goalId: goalId, uid: memberId }).subscribeNode(taskId);
        let task = {
          taskId: taskData.$id,
          from: 1234567890, // TODO: change
          duration: taskData.durationRemaining,
          cachedTitle: taskData.name,
          cachedFinishedAt: null,
        };

        console.log('onAddTaskToSession', sessionData)
        let tasksInSession = sessionData.tasks || []
        //console.log('onAddTaskToSession', task, goalId, memberId, sessionId)

        this.$models.taskMeta
        .with({
          goalId: goalId,
          uid: memberId,
        })
        .update(taskId, {
          sessionId: sessionId,
        });

        let tasks = [...tasksInSession.filter(item => item.taskId !== task.taskId), task];
        this.$models.userDayplannerSessions.update(sessionId, {
          tasks: tasks,
        });

        this.$models.userDayplannerSessions.update(sessionId, {
          tasks: tasks,
        });

        let plannedTask = {
          dateString: sessionData.dateString,
          taskId: taskData.$id,
          sessionId: sessionId,
          commitmentId: sessionData.commitmentId,
          goalId: goalId,
          assignedUserId: memberId,
          // createdAt: moment.currentTime().unix(),
          finished: false
        };
        this.$models.userDayplannerTasks.add(plannedTask)
        // TODO: update sortidx
      }
    },

    onRemoveTaskFromSession( taskObject = null, sessionObject = null, transfer = false ) {

      let task    = taskObject || this._task_info()
      let session = sessionObject || this._session_info();

      if (transfer) {
        this.$models.taskMeta
        .with({
          goalId:   task.goalId,
          uid:      task.memberId,
        })
        .update(task.taskId, {
          sessionId: sessionObject.sessionId
        });
      } else {
        this.$models.taskMeta
        .with({
          goalId:   task.goalId,
          uid:      task.memberId,
        })
        .update(task.taskId, {
          sessionId: null
        });
      }
         // TODO: update sortidx

      //this.$userDayplannerTasks.remove( goal_id, soft_delete ).then(() => {

      if (session.tasksInSession) {
        let tasks = session.tasksInSession.filter(item => item.taskId !== task.taskId);

        if ( session.sessionId ) {
          this.$models.userDayplannerSessions.update(session.sessionId, {
            tasks: tasks,
          });

          // remove task from unfinished tasks:
          if (this.dayplanner_unfinished_tasks) {
            this.dayplanner_unfinished_tasks.forEach(item => {
              if (item.$state.taskId === task.taskId) {
                this.$models.userDayplannerTasks.remove(item.$id)
              }
            })
          }
        }
      }
    },

    onRemoveUnfinishedTasksFromSessions() {
      if (this.dayplanner_unfinished_tasks) {
       // console.log('onRemoveUnfinishedTasksFromSessions', this.dayplanner_unfinished_tasks)
        let timeoutDistance = 0
        this.dayplanner_unfinished_tasks.forEach(task => {
          setTimeout(() => {
            let session = this.$models.userDayplannerSessions.subscribeNode(task.$state.sessionId)
            session.$promise.then(() => {
              let tasks = session.tasks
              if (tasks) {
                tasks = tasks.filter(item => item.taskId !== task.$state.taskId);
                //console.log(tasks)
                this.$models.userDayplannerSessions.update(task.$state.sessionId, {
                  tasks: tasks,
                });
              }
              console.log('onRemoveUnfinishedTasksFromSessions task', task)
              this.$models.taskMeta
              .with({
                goalId:   task.$state.goalId,
                uid:      task.$state.assignedUserId,
              }).update(task.$state.taskId, {
                sessionId: null
              });
              this.$models.userDayplannerTasks.remove(task.$id)
            })
          },
          timeoutDistance)
          timeoutDistance += 5
        })
      }
    },

    /* ---------------------------------------------------------------------- */
    onDuplicateTask() {
      let task = this._task_info()
      this.$api.task_duplicate({
        goal_id:   task.goalId,
        member_id: task.memberId,
        task_id:   task.$id,
      })
    },

    /* ---------------------------------------------------------------------- */
    onMoveTaskToGoal() {
      let task = this._task_info()

      this.$goal_commitment_prompt({
        preselectedGoalId: task.goalId,
        filterGoalId: null, /* also allow to move inside same goal */
        filterCommitmentId: task.laneId
      }).then(({ targetGoalId, targetCommitmentId, targetMemberId, done }) => {

        if ( targetGoalId === task.goalId ) {
          return this.$api.task_assign_to_lane({
            /* Item is changing owner and now has the user ID of the target
             * lane (this one). item.memberId is the old user ID! */
            old_member_id:  task.memberId,
            new_member_id:  targetMemberId,
            goal_id:        task.goalId,
            lane_id:        targetCommitmentId,
            task_id:        task.$id
          }).then(() => done)
        }

        if ( targetGoalId === task.laneId && targetCommitmentId === task.laneId ) {
          return done();
        }

        return this.$api.task_assign_to_goal({
          src_goal_id: task.goalId,
          dst_goal_id: targetGoalId,
          src_commitment_id: task.laneId,
          dst_commitment_id: targetCommitmentId,
          src_member_id: task.memberId,
          dst_member_id: targetMemberId,
          task_id: task.$id
        }).then(() => done)

      }).then(done => {
        done();
        this.$message({
          message: 'Task successfully moved',
          type: 'success'
        });
      }).catch(e => {

        console.error(e)
        // TODO: call done here! check for permission denied error
      })
    },

    /* ---------------------------------------------------------------------- */
    onRemoveTask(soft_delete) {
      // Alternative: this.task.remove(soft_delete)
      /* overwritten in TaskPage */
      let task = this._task_info()
      // console.log("task", task, this.task, this.goalId)

      if ( soft_delete ) {
        this.$api.task_delete({
          member_id:   task.memberId,
          task_id:     task.$id,
          goal_id:     task.goalId,
          soft_delete: true
        })
      } else {
        let options = { title: (this.task || {}).name };
        this.$confirm_delete_prompt('task', options).then(({ notify }) => {
          this.$api.task_delete({
            member_id:   task.memberId,
            task_id:     task.$id,
            goal_id:     task.goalId,
            soft_delete: soft_delete
          }).then(notify)
        }).catch(e => e)
      }
      this.onRemoveTaskFromSession()
    },

    /*onRemoveTaskFromSession() {
      let task = this._task_info()
      let tasks = [...this.tasksInSession.filter(item => item.taskId !== task.taskId)]
      this.$models.userDayplannerSessions.update(task.sessionId, {
        tasks: tasks
      })
    },*/

    /* ---------------------------------------------------------------------- */
    onRestoreTask() {
      // task.$id
      /* this.$models.taskMeta.with({
        goalId:this.goalId,
        uid:  this.memberId
      }).update(this.task.$id, { deleted: false }) */
      // this.task.update({ deleted: false }) // TODO: use restore?
      this.task.restore()
      // this.$api.task_restore
    },

    /* ---------------------------------------------------------------------- */
    onStartTaskTimer() {
      // TODO
      //let task = this._task_info()
      //console.log("onStartTaskTimer", task)
    },

    /* ---------------------------------------------------------------------- */
    onTaskSetLabel( label ) {
      if ( label === 'default' ) {
        label = null;
      }
      let task = this._task_info()
      this.$models.taskMeta
        .with({
          goalId: task.goalId,
          uid:    task.memberId
        })
        .update(task.$id, { label: label || null })
    },

    /* ---------------------------------------------------------------------- */
    onTaskSetReward( reward ) {
      console.log("onTaskSetReward", reward)
      let task = this._task_info()
      this.$models.taskMeta
        .with({
          goalId: task.goalId,
          uid:    task.memberId
        })
        .update(task.$id, { reward: reward || null })
    },

    onStartTimer(duration) {
      console.log('onStartTimer Taskmanagement', this._task_info(), this._task_info().memberId)
      let timer_data = this.session_user_timer

      // TODO: let task_info = this._task_info()

      /*if ( !timer_data ) {
        console.warn("No timer")
        return
      }*/
      if (timer_data
        && this.session_timer_taskId !== this.task_meta.$id
        && timer_data.taskId !== ''
        && !timer_data.paused
        && timer_data.startedAt
        && timer_data.startedAt + timer_data.durationRemaining > moment.currentTime().unix()) {
        this.$confirm('There is already a timer running for a different task. The other timer will stop. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.session_timer_start({
            taskId: this.task_meta.$id,
            commitmentId: this.task_meta.laneId,
            goalId: this.goalId,
            memberId: this._task_info().memberId,
            duration: duration
          })
        })
      } else {
        this.session_timer_start({
          taskId: this.task_meta.$id,
          commitmentId: this.task_meta.laneId,
          goalId: this.goalId,
          memberId: this._task_info().memberId,
          duration: duration
        })
      }
    },

    onPauseTimer() {
      this.session_timer_pause({
        taskId: this.task_meta.$id,
        commitmentId: this.task_meta.laneId,
        goalId: this.goalId
      })
    },

    onStopTimer() {
      this.session_timer_stop()
    },

    /* ---------------------------------------------------------------------- */
    onCheckTask( done ) {
      //console.log("onCheckTask", done);

      if ( done ) {
        this.session_timer_stop()

        this.task_meta_update({
          done: true,
          finishedAt: moment.currentTimeServer('REALTIMEDB'),
          durationDone: this.task.durationRemaining, /* this.taskDurationDone ? */
          durationRemaining: 0 })

      } else {
        this.task_meta_update({
          done: false,
          /* duration remaining neu berechnen
            TODO: taskDuration is only available in TaskPage!
          */
          durationRemaining: Math.max(0, this.taskDuration - this.taskDurationDone) || 0
        })
        // don't update finishedAt time. not necessary
      }

      let task = this._task_info()

      if ( done ) {
        this.$api.activity_create_log({
          task_id:    task.$id,
          goal_id:    task.goalId,
          member_id:  task.memberId,
        });

        this.$notify.success({
          type: 'success',
          message: 'Task complete. Nice work!'
        });

        // play sound
        this.task_finished_sound.play()

        // this.mockNotificationTaskComplete()

        // Bug bounty
        if ( FEATURE_BUG_BOUNTY ) {
          if ( this.task.reward) {

            // TODO: Per goal reward
            /*
            let bountylist = this.$models.userPublic
              .getNode( this.$models.user.defaultUserId )
              .bugbounty || {};
            let currentCount = bountylist[ this.task.reward ] || 0
            this.$models.userPublic.update( this.$models.user.defaultUserId, {
              [ 'bugbounty/' + this.task.reward ]: currentCount + 1
            })
            */

            this.$models.userPublic.transaction(
              this.$models.user.defaultUserId,
              'bugbounty/' + this.task.reward,
              'inc' );
          }
        }

        // remove task from unfinished tasks:
        if (this.dayplanner_unfinished_tasks) {
          this.dayplanner_unfinished_tasks.forEach(item => {
            if (item.$state.taskId === task.$id) {
              this.$models.userDayplannerTasks.update(item.$id, {
                finishedAt: moment.currentTime().unix(),
                finished: true
              })
            }
          })
        }
      } else {
        // remove task from unfinished tasks:
        if (this.dayplanner_unfinished_tasks) {
          let unfinished_task = this.$models.userDayplannerTasks.subscribeQuery({
              key: "taskId",
              value: task.$id,
              limit: 1
            })
          unfinished_task.$promise.then(() => {
            if (unfinished_task) {
              //console.log('unfinished_task', unfinished_task)
              unfinished_task.itemsAsArray().forEach(item => {
                this.$models.userDayplannerTasks.update(item.$id, {
                  finishedAt: null,
                  finished: false
                })
              })
            }
          })
        }
      }

      /*this.$api.task_set_done({
        goal_id:    this.goalId,
        task_id:    this.task.$id,
        member_id:  this.memberId,
        task_done:  !this.task.done
      });*/
    },

    /* ---------------------------------------------------------------------- */
    mockNotificationTaskComplete() {

      let task_name = this.task.name

      let SHOW_RANDOM_GIF = moment().hours() > 17 // Only show gifs after 17:00

      setTimeout(() => {
        this.$notify.success({
          type: 'success',
          title: 'Your work is getting noticed!',
          message: '+ 1 view on task: ' + task_name + ' (1 view)'
        })
      }, 2000);

      /*
      setTimeout(() => {
        this.$notify.success({
          type: 'success',
          title: Math.random() > 0.5 ? 'Achim says' : 'Thomas says',
          dangerouslyUseHTMLString: true,
          duration: 6500,
          message: `
          <img src="https://media.giphy.com/media/3o751YVqovWIxqJC5q/giphy.gif" />
          <br />Task: ${task_name} (1 likes)`
        })
      }, 5000);
      */

      if ( SHOW_RANDOM_GIF ) {
        setTimeout(() => {
          this.getRandomGif('motivation').then(gif_url => {
            this.$notify.success({
              type: 'success',
              title: Math.random() > 0.5 ? 'Achim says' : 'Thomas says',
              dangerouslyUseHTMLString: true,
              duration: 8500,
              message: `
                <img src="${gif_url}" />
                <br />Task: ${task_name} (1 likes)`
            })
          })
        }, 5000);

        setTimeout(() => {
          this.$notify.success({
            type: 'success',
            dangerouslyUseHTMLString: true,
            title: 'Your work is getting noticed!',
            message: `+ 1 view on task: ${task_name} (2 views)`
          })
        }, 9000);

        /*
        setTimeout(() => {
          this.$notify.success({
            type: 'success',
            title: 'Your cool boss says',
            dangerouslyUseHTMLString: true,
            duration: 6500,
            message: `
            <img src="https://media.giphy.com/media/oBPOP48aQpIxq/giphy.gif" />
            <br />Task: ${task_name} (2 likes)`
          })
        }, 13000);
        */

        setTimeout(() => {
          this.getRandomGif('respect').then(gif_url => {
            this.$notify.success({
              type: 'success',
              title: 'Your cool boss says',
              dangerouslyUseHTMLString: true,
              duration: 8500,
              message: `
                <img src="${gif_url}" />
                <br />Task: ${task_name} (2 likes)`
            })
          })
        }, 15000);
      }
    },

    /* ---------------------------------------------------------------------- */

    onAddToDayplan(task) {
      // TODO: Just add to local storage
      alert('NOT IMPLEMENTED')
    },

    onAssignTaskToUser(task) { // MOVE: TaskManagement
      // 1. show prompt and ask for user and message (DropTaskPrompt)
      // 2. check if user is part of this goal otherwise show info
      // 4. this.$api.contact_send_*_task({ receiverUserId, message, taskId, memberId, goalId, commitmentId })

      let task_info = this._task_info();
      this
        .$task_drop_prompt({ data: task_info, contactId: null })
        .then(({ config, done }) => {

          console.log("onSendTask: config", config, task_info)

          let payload = {
            receiverUserId: config.receiverUserId,
            message:        config.message,
            taskId:         task_info.taskId,
            goalId:         task_info.goalId,
            memberId:       task_info.memberId,
            commitmentId:   task_info.laneId, // REMOVE
          };

          let send_task = config.copy
            ? this.$api.contact_send_task_copy
            : this.$api.contact_send_existing_task;

          send_task(payload).then(done).catch(err => {
            this.$message.error(err.message)
            done();
          });
        })
    },
  }
}
